import { EmptyState } from '@brain/ui'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Link } from '@tanstack/react-router'
import { ClipboardList } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { formatDateTime } from '../../components/meetings/MeetingList.tsx'
import { PrepBriefView } from '../../components/people/PrepBriefView.tsx'
import { prepQuery } from '../../lib/people-m4.ts'

/** Stored prep brief (§16.3) – the link of the notification 15 minutes before a meeting. */
export const Route = createFileRoute('/_app/vorbereitung/$prepId')({ component: PrepPage })

function PrepPage() {
  const { t } = useTranslation()
  const { prepId } = Route.useParams()
  const q = useQuery(prepQuery(prepId))
  if (q.isError)
    return (
      <div className="flex flex-1 items-center justify-center">
        <EmptyState title={t('crm.prep.notFound')} description={t('crm.prep.notFoundText')} />
      </div>
    )
  const b = q.data
  return (
    <div className="min-w-0 flex-1 overflow-y-auto">
      <div className="mx-auto flex max-w-3xl flex-col gap-4 px-4 py-4 md:px-8 md:py-6">
        <header data-tauri-drag-region className="flex items-start gap-3">
          <span className="mt-1 flex size-9 shrink-0 items-center justify-center rounded-tile bg-pop-tint text-pop-fg">
            <ClipboardList size={18} strokeWidth={1.9} />
          </span>
          <div className="min-w-0 flex-1">
            <p className="meta-label">{t('crm.prep.title')}</p>
            <h1 className="text-[22px] text-text-1">{b?.event.title ?? t('common.loading')}</h1>
            {b && (
              <p className="text-[13px] text-text-2">
                {formatDateTime(b.event.startsAt)}
                {b.event.meetingId && (
                  <>
                    {' · '}
                    <Link
                      to="/meetings/$meetingId"
                      params={{ meetingId: b.event.meetingId }}
                      className="text-pop-fg"
                    >
                      {t('crm.prep.openMeeting')}
                    </Link>
                  </>
                )}
              </p>
            )}
          </div>
        </header>
        {b && <PrepBriefView brief={b} />}
      </div>
    </div>
  )
}
